/**
 * @type {{
 *    adaptive: "adaptive",
 *    compact: "compact",
 *    perspective: "perspective",
 *    quadrata: "quadrata",
 *    victor: "victor",
 * }}
 */
export const TOOL_TEMPLATE = {
  adaptive: "adaptive",
  compact: "compact",
  perspective: "perspective",
  quadrata: "quadrata",
  victor: "victor",
};

/**
 * @enum {{
 *  time: 'Time',
 *  volume: "Volume",
 *  price: "Price",
 *  buyer: "Buyer",
 *  seller: "Seller",
 * }}
 */
export const TRADE_HISTORY_FIELD = {
  time: "Time",
  "Time": 'time',
  volume: "Volume",
  Volume: "volume",
  price: "Price",
  Price: 'price',
  buyer: "Buyer",
  Buyer: 'buyer',
  seller: "Seller",
  Seller: "seller"
};

export const TIME_FORMAT_DEFAULT = "HH:mm:ss";

export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
export const SHORT_MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
export const DAY_NAMES = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
export const SHORT_DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const SHORT_DATE_FORMAT = "DD-MMMM-YYYY";
export const SHORT_DATE_MOBILE_FORMAT = "DD-MM-YYYY";

export const arrayColor = ["#00A1FF", "#082B45", "#85586F", "#D0B8A8"];

export const FORMAT_NUMBER = "#,##0.0000";
export const POSITIVE_NUMBER_FORMAT = 'n';
export const POSITIVE_CHANGE_NUMBER_FORMAT = '+n';

export const KEY_API_CHANGE_COLOR = ["highestDailyChangePercent", "changeOfPeriodPercent", "lowestDailyChangePercent"]

export const TAB = {
  history: 1,
  sharePrice: 2,
};

export const CHART_PATTERN =  /** @type { const }*/([
  'Solid',
  'ShortDash',
  'ShortDot',
  'ShortDashDot',
  'ShortDashDotDot',
  'Dot',
  'Dash',
  'LongDash',
  'DashDot',
  'LongDashDot',
  'LongDashDotDot'
])

export const CalendarHeader = {
  EMPTY_LEFT_HEADER: 'empty_left_header',
  EMPTY_RIGHT_HEADER: 'empty_right_header',
  EMPTY_LEFT_BOTTOM: 'empty_left_bottom'
}

export const LONG_DATE_SCREEN_READER = "dddd, MMMM DD YYYY HH:mm:ss"
export const DATE_SCREEN_READER = "dddd, MMMM DD YYYY"


 
